module.exports = __webpack_public_path__ + "static/pic2-fdd47f0f5cf6f745c8cde949ecb31f42.png";